import gql from "graphql-tag";

export const MY_LEAVE_GET_YEARLY_DAYS_BY_CONTRACT = gql`
  query leaveYearlyDaysByContract($contract: String!, $year: String!) {
    leaveYearlyDaysByContract(contract: $contract, year: $year) {
      _id
      year
      availableLeaveDays
      availableStudyLeaveDays
      availableESZJTV19LeaveDays
      availableCovidPlus10LeaveDays
      availableEmergencyLeaveDays
      fulfilledLeaveDays
      fulfilledStudyLeaveDays
      fulfilledAbsenceDays
      fulfilledCovidPlus10Days
      fulfilledESZJTV19Days
      fulfilledEmergencyDays
    }
  }
`;
